// Ödeme Entegrasyonu Ekle penceresi (PayTR / Moka United / Tacreo Kart) kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'integrations.addPayment';

export const addPaymentIntegrationModalGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'Ödeme entegrasyonu nasıl eklenir?'),
  intro: t(`${G}.intro`, 'Kartla ödeme almak için ödeme sağlayıcınızın mağaza bilgilerini buraya girersiniz. Anahtarlar, test modu veya 3D Secure yanlışsa ödemeler başarısız olur. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Ödeme Entegrasyonu Ekle'),
    body: t(`${G}.regions.body`, 'Sağlayıcı, şube, durum ve bilgiler'),
    footer: t(`${G}.regions.footer`, 'İptal / Kaydet'),
  },
  steps: [
    {
      region: 'body',
      title: t(`${G}.s1.title`, '1. Sağlayıcıyı seçin'),
      text: t(`${G}.s1.text`, '"Sağlayıcı" listesinde PayTR, Moka United ve Tacreo Kart seçilebilir; ParamPos "Yakında" etiketlidir ve seçilemez. Sağlayıcıya göre altta farklı bilgi alanları açılır.'),
      tips: [
        t(`${G}.s1.tip1`, 'Tacreo Kart ("Sadece Tacreo") yalnız Tacreo e-ticaret mağazası içindir; diğer firmalar kullanmamalıdır.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Şube veya şirket geneli'),
      text: t(`${G}.s2.text`, '"Şube" boş bırakılırsa kayıt "Şirket Geneli (tüm şubeler)" olur. Bir sağlayıcı için şirket genelinde bir, her şubede bir kayıt açılabilir; aynısı varsa kayıt reddedilir, mevcut kaydı düzenleyin. Ödemede önce şubenin aktif kaydı, yoksa şirket geneli kayıt kullanılır.'),
      tips: [
        t(`${G}.s2.tip1`, 'E-ticaret sitenizde kartla ödeme için şirket geneli (şube seçilmemiş) bir kayıt gerekir.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Durum: Aktif, Test Modu, 3D Secure'),
      text: t(`${G}.s3.text`, '"Aktif" açıkken kayıt ödemelerde kullanılır. "Test Modu" sağlayıcının test ortamına bağlanır; test bilgileriyle deneme yapıp canlıya geçmeden kapatın. "3D Secure" kart sahibinin bankasından doğrulama ister; Tacreo Kart\'ta bu seçenek yoktur, kapalı kaydedilir.'),
      tips: [
        t(`${G}.s3.tip1`, 'Moka\'da Test Modu açıkken test bilgisi kullanın. Canlı DealerCode ile açık bırakılırsa Moka "bayi bulunamadı" döner.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s4.title`, '4. Sağlayıcı bilgilerini girin'),
      text: t(`${G}.s4.text`, 'PayTR: Merchant ID, Merchant Key ve Merchant Salt zorunludur; PayTR Mağaza Panelinde Mağaza Bilgileri > Entegrasyon Bilgileri bölümünden alınır. Moka United: DealerCode (Bayi Kodu), Username (API Kullanıcı Adı) ve Password (API Şifresi) zorunludur; Moka bayi panelinizden alınır. Tacreo Kart: Affiliate Id ve Hash zorunludur; API Base URL boşsa https://services.tacreocard.com kullanılır, Cüzdan (Tümü / Giyim / Restoran) ve Branch Code (varsayılan 0) seçilir.'),
      tips: [
        t(`${G}.s4.tip1`, 'PayTR "Kayıtlı Site Adresi (opsiyonel)": mağaza bilgileriniz yalnız tek bir siteye tanımlıysa o sitenin adresini yazın. Ödeme başka bir adreste başlarsa (ör. e-posta linki) müşteri bu sitedeki güvenli ödeme sayfasına yönlendirilir ve PayTR domain kilidine takılmaz. Ödeme zaten bu adreste açılıyorsa boş bırakın.'),
        t(`${G}.s4.tip2`, 'Site adresi http:// veya https:// ile başlamalıdır; yalnız alan adı kısmı saklanır.'),
        t(`${G}.s4.tip3`, 'Gizli alanları göz simgesiyle görünür yapıp kontrol edebilirsiniz.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s5.title`, '5. Kaydedin'),
      text: t(`${G}.s5.text`, '"Kaydet" eksik zorunlu alan varsa kırmızı uyarı gösterir. Kayıt başarılı olunca pencere kapanır, liste yenilenir.'),
    },
  ],
});
